import { render, staticRenderFns } from "./ArchivesWorkNotPaddyShow.vue?vue&type=template&id=bed5c0c4&"
import script from "./ArchivesWorkNotPaddyShow.vue?vue&type=script&lang=js&"
export * from "./ArchivesWorkNotPaddyShow.vue?vue&type=script&lang=js&"
import style0 from "./ArchivesWorkNotPaddyShow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports